import { render, staticRenderFns } from "./Facility.vue?vue&type=template&id=0464b5e5&scoped=true"
import script from "./Facility.vue?vue&type=script&lang=js"
export * from "./Facility.vue?vue&type=script&lang=js"
import style0 from "./Facility.vue?vue&type=style&index=0&id=0464b5e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0464b5e5",
  null
  
)

export default component.exports